var _image, _image2, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuarkyIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128.18 193.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-13.42 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.92,85.3a3.84,3.84,0,1,0,3.84-3.84h0a3.81,3.81,0,0,0-3.83,3.81v0h0",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    transform: "translate(-13.42 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.03,
    y: 80.63,
    width: 9.32,
    height: 9.32,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    transform: "translate(-13.42 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.49,85.31a3.83,3.83,0,1,0,3.83-3.83,3.82,3.82,0,0,0-3.83,3.83v0h0",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    transform: "translate(-13.42 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.69,
    y: 80.68,
    width: 9.25,
    height: 9.25,
    style: {
      fill: "none"
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "e",
    width: 79,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABQCAYAAABYtCjIAAAACXBIWXMAAAsSAAALEgHS3X78AAAB4UlEQVR4Xu3aS2sTUQCG4Sex3lCq1IWIbkTBreB/8kf1P7ly6UIEQQ14qXiptjYuzgQVlIKf2BG/F4aETBbhyZlzzoQs1uu19nstj3tD+3XFCypeUPGCihdUvKDiBRUvqHhBxQsqXlDxgooXVLyg4gUVL6h4QcULKl5Q8YKKF1S8oOIFFS+oeEHFCypeUPGCihdUvKDiBRUvaOu4N/z1FrsLbA5YY219f3b/wlzM5p+hA21pfKFnpgM+T8chjuaEOA+8AXcK53AJO9Mj7OE13uIjDucCOJfLdoGzuILbuIXr07nneILH0/N3FruzAJwL3hLncQP3cHd6vsQKj3ARRzjAF2MuPNHmgrcZeTu4iTvGyNvCNWwb897KuIT3DcgTbU54mzlvG5enx83CsY+r02unfVuJT7Tu84LmMvLWxjy2b6yqb3DB+Hx7eIYX07kDM5jvmBfeJ7wyVtVLeO/HBeOhgfjBDOY75oN3ZOzhnuKBMfJ+tlVZGcgded+1GXkvjTuJlX9gkzyPOwx6e/ZH6g8D/0fd5wUVL6h4QcULKl5Q8YKKF1S8oOIFFS+oeEHFCypeUPGCihdUvKDiBRUvqHhBxQsqXlDxgooXVLyg4gUVL6h4QcULKl5Q8YKKF1S8oK/gvXPryxndegAAAABJRU5ErkJggg=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "f",
    width: 79,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABQCAYAAABYtCjIAAAACXBIWXMAAAsSAAALEgHS3X78AAAB3klEQVR4Xu3aS2sTUQCG4Se13lBaqQsR3YiCW8F/4g/tP3Hl0oUIghrwUvFSbW1czMQLKAU/sUf8XhgSMlmEJ2fOOROyWK1W2u+1cdwb2q8rXlDxgooXVLyg4gUVL6h4QcULKl5Q8YKKF1S8oOIFFS+oeEHFCypeUPGCihdUvKDiBRUvqHhBxQsqXlDxgooXVLyg4gUVL6h4QZvHveFvt9i14OsBK6xW9wz3L8zFKP8MndE2TF/omfmAT/NxiKOREIfAm+FO4Ry2sTM/wh5e4Q0+4HAUwFEu2wXO4jJu4Sauzeee4TEezc/fLnbHABwFbwPncR13cWd+voElHuIijnCAzxRv3Xrk7eAGbptG3iauYss07y1Nl/C+CfJEGwlvPedt4dL8uF449nFlfu20byvxidZ9XtAoI29lmsf2Tavqa1wwfb49PMXz+dyBAeY7xsL7iJemVXUb7/y4YDwwIb43wHzHOHhHpj3cE9w3jbyfbVWWJuSOvO9aj7wXpjuJpX9gkzzEHQa9Pfsj9YeB/6Tu84KKF1S8oOIFFS+oeEHFCypeUPGCihdUvKDiBRUvqHhBxQsqXlDxgooXVLyg4gUVL6h4QcULKl5Q8YKKF1S8oOIFFS+oeEHFCype0BeOrXPXYKvY4wAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,0H29.4A12.16,12.16,0,0,0,17.26,12.14v169A12.16,12.16,0,0,0,29.4,193.28h96.52a12.16,12.16,0,0,0,12.14-12.14v-169A12.15,12.15,0,0,0,125.92,0ZM30.42,186.39a2.79,2.79,0,0,1-2,.84,2.84,2.84,0,1,1,2.83-2.85A2.81,2.81,0,0,1,30.42,186.39Zm24.55,0a2.84,2.84,0,1,1,.83-2A2.85,2.85,0,0,1,55,186.4Zm24.74,0a2.84,2.84,0,1,1,.83-2A2.85,2.85,0,0,1,79.71,186.4Zm24.66,0a2.84,2.84,0,1,1,.83-2A2.85,2.85,0,0,1,104.37,186.4Zm24.55,0a2.84,2.84,0,1,1,.83-2A2.85,2.85,0,0,1,128.92,186.4Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#1e1e1e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.16,
    y: 184.2,
    width: 9.66,
    height: 8.94,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 184.24,
    r: 4.83,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.79,
    y: 184.2,
    width: 9.66,
    height: 8.94,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.62,
    cy: 184.24,
    r: 4.83,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.41,
    y: 184.2,
    width: 9.66,
    height: 8.94,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.24,
    cy: 184.24,
    r: 4.83,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.03,
    y: 184.2,
    width: 9.66,
    height: 8.94,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.87,
    cy: 184.24,
    r: 4.83,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.66,
    y: 184.2,
    width: 9.66,
    height: 8.94,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.49,
    cy: 184.24,
    r: 4.83,
    style: {
      fill: "#fff39d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.46,187.08a2.84,2.84,0,1,1,2.83-2.85h0A2.85,2.85,0,0,1,28.46,187.08Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,187.08a2.84,2.84,0,1,1,2.84-2.84h0A2.84,2.84,0,0,1,53,187.08Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.74,187.08a2.84,2.84,0,1,1,2.84-2.84h0a2.84,2.84,0,0,1-2.84,2.84Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4,187.08a2.84,2.84,0,1,1,2.84-2.84h0A2.84,2.84,0,0,1,102.4,187.08Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,187.08a2.84,2.84,0,1,1,2.84-2.84h0A2.84,2.84,0,0,1,127,187.08Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("image", {
    width: 1343,
    height: 347,
    transform: "translate(30.56 13.7) scale(0.05)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.11,89.82a.88.88,0,0,1-.86.88H22.18a.87.87,0,0,1-.89-.85v0h0V80.77a.88.88,0,0,1,.89-.88h9.05a.87.87,0,0,1,.88.86h0Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.01,
    y: 90.7,
    width: 1.74,
    height: 1.92,
    style: {
      fill: "#f4ef98"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.78,
    y: 90.72,
    width: 1.74,
    height: 1.92,
    style: {
      fill: "#f4ef98"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.78,
    y: 77.96,
    width: 1.74,
    height: 1.92,
    style: {
      fill: "#f4ef98"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.01,
    y: 77.94,
    width: 1.74,
    height: 1.92,
    style: {
      fill: "#f4ef98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78,85.31a3.09,3.09,0,1,1-3.09-3.1,3.09,3.09,0,0,1,3.09,3.1Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "0.43199998140335083px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.13,85.31a.44.44,0,0,1-.44.44h0a.45.45,0,0,1,0-.89A.47.47,0,0,1,27.13,85.31Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "0.43199998140335083px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.28,
    cy: 85.29,
    r: 3.15,
    style: {
      fill: "#3f3f3f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    width: 28,
    height: 28,
    transform: "translate(8.28 80.32) scale(0.35)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAB+uAAAfrgF/G/83AAAAVklEQVRIS+3WwQnAQAhE0TGkIGuyLGtyakrOgRAIzO5p3klE+FdjZi6SAICIwJs/+6/bzMRJEt39OFw1VxUObOagnINyDso5KOegnINyDso5KBe7X/0bZJESgSM4CIYAAAAASUVORK5CYII=",
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.72,89.83a.87.87,0,0,1-.85.89h-9.08a.86.86,0,0,1-.88-.86v0h0v-9a.87.87,0,0,1,.86-.88h9.07a.9.9,0,0,1,.89.88Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.62,
    y: 90.72,
    width: 1.74,
    height: 1.92,
    style: {
      fill: "#e2d6a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.4,
    y: 90.74,
    width: 1.74,
    height: 1.92,
    style: {
      fill: "#e2d6a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.4,
    y: 77.98,
    width: 1.74,
    height: 1.92,
    style: {
      fill: "#f4ef98"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.62,
    y: 77.96,
    width: 1.74,
    height: 1.92,
    style: {
      fill: "#f4ef98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39,85.32a3.09,3.09,0,1,1-3.09-3.09h0A3.09,3.09,0,0,1,131.39,85.32Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "0.43199998140335083px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.74,85.32a.44.44,0,0,1-.44.44h0a.44.44,0,1,1,0-.88A.44.44,0,0,1,128.74,85.32Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "0.43199998140335083px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.9,
    cy: 85.3,
    r: 3.15,
    style: {
      fill: "#3f3f3f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#c)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 28,
    transform: "translate(110.16 80.36) scale(0.35)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAYAAACQ0cTtAAAACXBIWXMAAB+uAAAfrgF/G/83AAAAUUlEQVRIS+3WsQ2AUAwDURuxUXbKTpkWBgD0BTpR+VVRUlwbz8whSbZ1h9y7qi6x1by6P82bfpQYIjFEYojEEIkhEkMkhkgMsXe3pG/v9Nv9CTsEBgaaxZ/CAAAAAElFTkSuQmCC",
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000001192092896
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.78,
    y: 94.58,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 97.51,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 97.51,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.78,
    y: 82.48,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 85.41,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 85.41,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.78,
    y: 70.35,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 73.28,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 73.28,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.78,
    y: 58.33,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 61.26,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 61.26,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.78,
    y: 46.26,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 49.19,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.97,
    cy: 49.19,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.76,
    y: 94.58,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 97.51,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 97.51,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.76,
    y: 82.48,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 85.41,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 85.41,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.76,
    y: 70.35,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 73.28,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 73.28,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.76,
    y: 58.33,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 61.26,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 61.26,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.51,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.75,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.76,
    y: 46.26,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 49.19,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.95,
    cy: 49.19,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.84,
    y: 94.58,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 97.51,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 97.51,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.84,
    y: 82.48,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 85.41,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 85.41,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.84,
    y: 70.35,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 73.28,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 73.28,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.84,
    y: 58.33,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 61.26,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 61.26,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.58,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.83,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.84,
    y: 46.26,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 49.19,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.03,
    cy: 49.19,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.91,
    y: 94.58,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 97.51,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 97.51,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.91,
    y: 82.48,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 85.41,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 85.41,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.91,
    y: 70.35,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 73.28,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 73.28,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.91,
    y: 58.33,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 61.26,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 61.26,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.66,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.91,
    y: 46.26,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 49.19,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.1,
    cy: 49.19,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.04,
    y: 94.58,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 97.51,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 97.51,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.04,
    y: 82.48,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 85.41,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 85.41,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.04,
    y: 70.35,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 73.28,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 73.28,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.04,
    y: 58.33,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 61.26,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 61.26,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.78,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.03,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.04,
    y: 46.26,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 49.19,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.23,
    cy: 49.19,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.11,
    y: 94.58,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 97.51,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 97.51,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.11,
    y: 82.48,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 85.41,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 85.41,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.11,
    y: 70.35,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 73.28,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 73.28,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.11,
    y: 58.33,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 61.26,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 61.26,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.86,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.11,
    y: 46.26,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 49.19,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3,
    cy: 49.19,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 98.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 95.05,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.19,
    y: 94.58,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 97.51,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 97.51,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 86.7,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 82.95,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.19,
    y: 82.48,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 85.41,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 85.41,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 74.57,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 70.82,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.19,
    y: 70.35,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 73.28,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 73.28,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 62.55,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 58.8,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.19,
    y: 58.33,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 61.26,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 61.26,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.94,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 50.48,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.18,
    y: 46.73,
    width: 0.7,
    height: 1.17,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.19,
    y: 46.26,
    width: 6.44,
    height: 5.86,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 49.19,
    r: 2.32,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.38,
    cy: 49.19,
    r: 1.98,
    style: {
      fill: "#e6e6e6"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19.19 157.57 38.07 157.57 38.07 158.01 37.85 158.01 37.85 152.77 38.07 152.77 38.07 153.21 19.19 153.21 19.19 152.33 38.07 152.33 38.28 152.33 38.28 152.77 38.28 158.01 38.28 158.44 38.07 158.44 19.19 158.44 19.19 157.57"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "30.11 171.4 29.64 173.07 28.64 173.07 28.17 171.4 28.17 156.49 30.11 156.49 30.11 171.4",
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.05 171.4 23.58 173.07 22.58 173.07 22.13 171.4 22.13 156.49 24.05 156.49 24.05 171.4",
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.17,
    y: 145.14,
    width: 1.94,
    height: 9.64,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.11,
    y: 145.14,
    width: 1.93,
    height: 9.64,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.17 171.4 35.71 173.07 34.72 173.07 34.25 171.4 34.25 156.49 36.17 156.49 36.17 171.4",
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.24,
    y: 145.14,
    width: 1.93,
    height: 9.64,
    style: {
      fill: "#b8af82"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.57 157.57 108.45 157.57 108.45 158.01 108.23 158.01 108.23 152.77 108.45 152.77 108.45 153.21 89.57 153.21 89.57 152.33 108.45 152.33 108.68 152.33 108.68 152.77 108.68 158.01 108.68 158.44 108.45 158.44 89.57 158.44 89.57 157.57"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "100.5 171.4 100.03 173.07 99.04 173.07 98.57 171.4 98.57 156.49 100.5 156.49 100.5 171.4",
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.44 171.4 93.97 173.07 92.98 173.07 92.51 171.4 92.51 156.49 94.44 156.49 94.44 171.4",
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.57,
    y: 145.14,
    width: 1.94,
    height: 9.64,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.51,
    y: 145.14,
    width: 1.93,
    height: 9.64,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.57 171.4 106.1 173.07 105.1 173.07 104.63 171.4 104.63 156.49 106.57 156.49 106.57 171.4",
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.63,
    y: 145.14,
    width: 1.93,
    height: 9.64,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.54,
    y: 145.14,
    width: 1.96,
    height: 8.9,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.4,
    y: 145.14,
    width: 1.96,
    height: 8.9,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.27,
    y: 145.14,
    width: 1.96,
    height: 8.9,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.13,
    y: 145.14,
    width: 1.96,
    height: 8.9,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.99,
    y: 145.14,
    width: 1.96,
    height: 8.9,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.78,
    y: 145.14,
    width: 1.96,
    height: 8.9,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.64,
    y: 145.14,
    width: 1.96,
    height: 8.9,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.68,
    y: 145.14,
    width: 1.96,
    height: 8.9,
    style: {
      fill: "#b8af82"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.82,
    y: 154.04,
    width: 50.54,
    height: 19.22,
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 154.3,
    width: 49.18,
    height: 18.7,
    style: {
      fill: "#3f3f3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,136.42a1.15,1.15,0,1,0,1.15-1.15h0a1.13,1.13,0,0,0-1.15,1.13v0h0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.15,132.59a1.15,1.15,0,1,0,1.15-1.15h0a1.13,1.13,0,0,0-1.15,1.13v0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.36,132.59a1.15,1.15,0,1,0,1.15-1.15h0a1.13,1.13,0,0,0-1.15,1.13v0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.36,137.19A1.15,1.15,0,1,0,77.51,136h0a1.13,1.13,0,0,0-1.15,1.13h0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,128.6a1.15,1.15,0,1,0,1.15-1.15h0a1.13,1.13,0,0,0-1.15,1.13v0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.36,128a1.14,1.14,0,0,0,1.16,1.14,1.15,1.15,0,0,0,0-2.3A1.13,1.13,0,0,0,76.36,128v0h0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,136.42a1.15,1.15,0,1,0,1.15-1.15h0A1.13,1.13,0,0,0,81,136.4v0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,132.59a1.15,1.15,0,1,0,1.15-1.15h0a1.13,1.13,0,0,0-1.15,1.13v0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,128.6a1.15,1.15,0,1,0,1.15-1.15h0A1.13,1.13,0,0,0,81,128.58v0",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#686868"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(0.48 45.76)",
    xlinkHref: "#e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(12.56 57.51)",
    xlinkHref: "#e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(24.81 57.51)",
    xlinkHref: "#e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(36.76 57.51)",
    xlinkHref: "#e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(48.83 45.31)",
    xlinkHref: "#e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(49.18 21.92)",
    xlinkHref: "#f",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(49.18 8.9)",
    xlinkHref: "#f",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(36.71 8.9)",
    xlinkHref: "#f",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(36.71 21.84)",
    xlinkHref: "#f",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(13.34 21.84)",
    xlinkHref: "#f",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(13.34 9.19)",
    xlinkHref: "#f",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 9.19)",
    xlinkHref: "#f",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(0.45 21.84)",
    xlinkHref: "#f",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.57,
    y: 152.77,
    width: 18.88,
    height: 5.24,
    style: {
      fill: "#3f3f3f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.18,
    y: 152.77,
    width: 18.88,
    height: 5.24,
    style: {
      fill: "#3f3f3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.63,134.67v0a12.92,12.92,0,0,1-18.23,1,13.93,13.93,0,0,1-1.14-1.17V117.59a2.09,2.09,0,0,1,.14-.17,3.5,3.5,0,0,1,.27-.28,2.91,2.91,0,1,1,4.27,4l-.12.12a7.09,7.09,0,1,0,10.4,9.64.74.74,0,0,1,.12-.13,2.81,2.81,0,0,1,2-.94,2.92,2.92,0,0,1,2.27,4.88Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.74,113.77a2.92,2.92,0,1,1-.17-4.13h0A3,3,0,0,1,28.74,113.77Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.41,127.3a2.9,2.9,0,1,1-.15-4.12A2.92,2.92,0,0,1,43.41,127.3Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,115.61a9.91,9.91,0,1,0,0,19.82m0,0,0,2.28h0a12.23,12.23,0,1,1,0-24.46",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,135.33a3.16,3.16,0,1,0-3.15-3.17h0a3.17,3.17,0,0,0,3.15,3.16m0,2.28a5.44,5.44,0,1,1,5.44-5.44h0A5.43,5.43,0,0,1,119.16,137.61Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07,121.19a3.9,3.9,0,1,0-3.88-3.92v0a3.91,3.91,0,0,0,3.88,3.9m0,2.81a6.72,6.72,0,1,1,6.72-6.71h0A6.71,6.71,0,0,1,117.07,124Z",
    transform: "translate(-13.42 0)",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuarkyIllustration);
export default __webpack_public_path__ + "static/media/icon-quarky-illustration.f3ffac619b2ddf09f4e097a8d133a662.svg";
export { ForwardRef as ReactComponent };